import { IsNotEmpty, IsString } from 'class-validator';

export class Communicator {
  @IsString()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  type: string;
}
